import { render } from "./AddContractTemplate.vue?vue&type=template&id=07989118"
import script from "./AddContractTemplate.vue?vue&type=script&lang=js"
export * from "./AddContractTemplate.vue?vue&type=script&lang=js"

import "./AddContractTemplate.vue?vue&type=style&index=0&id=07989118&lang=css"

import exportComponent from "/Users/elisabetta/Code/salvi-rental/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__